'use client';

import { useMemo } from 'react';

import { useLocale } from 'next-intl';
import dynamic from 'next/dynamic';

import { ourLocaleToTwLocale } from '@/blocks/components/TW';

import styles from '@/app/[lang]/economic-calendar/styles.module.scss';

const EconomicCalendar = dynamic(
  () => import('react-ts-tradingview-widgets').then((w) => w.EconomicCalendar),
  {
    ssr: false,
  },
);

export function EconomicCalendarWidget() {
  const lang = useLocale();
  return useMemo(
    () => (
      <div className={styles.economicCalendarWrapper}>
        <EconomicCalendar
          copyrightStyles={{
            parent: {
              display: 'none',
            },
          }}
          colorTheme="light"
          isTransparent={false}
          locale={ourLocaleToTwLocale(lang)}
          importanceFilter="-1,0,1"
          //@ts-ignore This property exists and needed
          // countryFilter="us,eu,it,nz,ch,au,fr,jp,za,tr,ca,de,mx,es,gb"
        />
      </div>
    ),
    [lang],
  );
}
